import { createBrowserRouter } from "react-router-dom";
import routes from './routes';
import { Login, Registration } from "modules/Public";
import ProtectedRoute from "./ProtectedRoute";

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <div className="h-screen flex items-center justify-center text-xl font-bold italic">ERROR</div>,
    element: <ProtectedRoute/>,
    children: [...routes].map(foo => {
      return {
        ...foo,
      }
    })
  },
  {
    path: '/login',
    errorElement: <div>error</div>,
    element: <Login/>
  },
  {
    path: '/register',
    errorElement: <div>error</div>,
    element: <Registration/>
  },
])

export default router
